import { render } from "./Template.vue?vue&type=template&id=1571526e"
import script from "./Template.vue?vue&type=script&lang=ts"
export * from "./Template.vue?vue&type=script&lang=ts"
script.render = render

export default script